import React from "react";
import { Box, Button, CardContent } from "@mui/material";
import { CardSpg, GridSpg } from "@duosoftbg/nacid-components";
import useAppSelector from "../../../../../hooks/redux/base/useAppSelector";
import { ACADEMIC_RECOGNITION_TYPE } from "../../../../../config/registers/common";
import useAppDispatch from "../../../../../hooks/redux/base/useAppDispatch";
import { setActiveTab } from "../../../../../store/redux/slice/SearchData/academicRecognitionData";
import RSearchAcademicRecognitionNacid from "./nacid/RSearchAcademicRecognitionNacid";
import RSearchAcademicRecognitionUniversities from "./universities/RSearchAcademicRecognitionUniversities";
import styled from "styled-components/macro";
import { useTranslation } from "react-i18next";

const RegistersTabButton = styled(Button)`
  border: 1px solid #d8d8d8;
  width: 100%;
  border-bottom: 0;
  min-height: 40px;
  border-radius: 0;
  cursor: default;
  height: 100%;
  text-transform: uppercase;
  :hover {
    background-color: ${(props) => props.theme.palette.primary.main};
  }
  &.inactive-tab {
    background-color: ${(props) => props.theme.palette.primary.contrastText};
    color: ${(props) => props.theme.palette.primary.main};
    cursor: pointer;

    :hover {
      background-color: #f5f5f5 !important;
    }
  }
`;

const RegistersTabButtonWrapper = styled(Box)`
  height: 100%;
`;

const RegistersTabButtonLeft = styled(RegistersTabButton)`
  border-right: 0;
`;

const RegistersTabButtonRight = styled(RegistersTabButton)`
  border-left: 0;
`;

const RSearchAcademicRecognition = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const { activeTab } = useAppSelector((state) => state.SearchData.academicRecognitionTab);

  const handleChangeTab = (tab) => (e) => {
    if (tab !== activeTab) {
      dispatch(setActiveTab({ activeTab: tab }));
    }
  };

  return (
    <CardSpg my={4} style={{ overflow: "visible" }}>
      <CardContent style={{ position: "relative" }}>
        <GridSpg container>
          <GridSpg item xs={6}>
            <RegistersTabButtonWrapper>
              <RegistersTabButtonLeft
                className={activeTab !== ACADEMIC_RECOGNITION_TYPE.NACID && "inactive-tab"}
                onClick={handleChangeTab(ACADEMIC_RECOGNITION_TYPE.NACID)}
                variant={"contained"}
                title={t("t.academicRecognition.nacid")}
              >
                {t("t.academicRecognition.nacid")}
              </RegistersTabButtonLeft>
            </RegistersTabButtonWrapper>
          </GridSpg>
          <GridSpg item xs={6}>
            <RegistersTabButtonWrapper>
              <RegistersTabButtonRight
                title={t("t.academicRecognition.universities")}
                className={activeTab !== ACADEMIC_RECOGNITION_TYPE.UNIVERSITIES && "inactive-tab"}
                onClick={handleChangeTab(ACADEMIC_RECOGNITION_TYPE.UNIVERSITIES)}
                variant={"contained"}
              >
                {t("t.academicRecognition.universities")}
              </RegistersTabButtonRight>
            </RegistersTabButtonWrapper>
          </GridSpg>
        </GridSpg>
        {activeTab === ACADEMIC_RECOGNITION_TYPE.NACID && <RSearchAcademicRecognitionNacid />}
        {activeTab === ACADEMIC_RECOGNITION_TYPE.UNIVERSITIES && <RSearchAcademicRecognitionUniversities />}
      </CardContent>
    </CardSpg>
  );
};

export default RSearchAcademicRecognition;
